// Suchbegriffe/Synonyme je Portal-Seite – ergänzt die Menü-Labels für die Funktionssuche im Header.
export const FEATURE_KEYWORDS = {
  '/portal/dashboard': 'start übersicht home startseite',
  '/portal/staff-dashboard': 'start übersicht home',
  '/portal/vorgaenge': 'ticket tickets anfrage schaden reparatur meldung mängel störung',
  '/portal/admin/objekte': 'immobilie haus liegenschaft weg gebäude einheit adresse objektverwaltung',
  '/portal/admin/kunden': 'eigentümer mieter kunde personen adressen kontakte kundenverwaltung',
  '/portal/dokumente': 'dateien upload pdf unterlagen ablage archiv',
  '/portal/admin/interne-dokumente': 'vorlagen formulare muster selbstauskunft intern download-link',
  '/portal/admin/vermietungen': 'mietbewerbung bewerbung bewerber vermieten wohnung absage zusage immoscout exposé mietobjekt leerstand',
  '/portal/admin/handwerker': 'dienstleister firma gewerk auftrag handwerkerverwaltung',
  '/portal/admin/prueffristen': 'wartung tüv prüfung aufzug rauchmelder legionellen fristen',
  '/portal/admin/sondereigentumsverwaltung': 'sev sondereigentum',
  '/portal/betriebskosten': 'nebenkosten abrechnung bka heizkosten umlage betriebskostenabrechnung',
  '/portal/mietuebersicht': 'miete sollstellung zahlungen mietübersicht',
  '/portal/nk-anpassung': 'nebenkostenvorauszahlung vorauszahlung anpassung',
  '/portal/mieterhoehung': 'mietanpassung mietspiegel erhöhung',
  '/portal/kautionsabrechnung': 'kaution sicherheit rückzahlung',
  '/portal/mietbescheinigung': 'bescheinigung nachweis vermieterbescheinigung',
  '/portal/quittungen': 'quittung beleg',
  '/portal/kuendigungen': 'kündigung auszug beendigung',
  '/portal/mietausfall': 'rückstand mahnung mietschulden zahlungsverzug',
  '/portal/admin/wirtschaftsplan': 'jahresabrechnung wirtschaftsplan hausgeld ja',
  '/portal/admin/aushang': 'aushang schwarzes brett treppenhaus hinweis',
  '/portal/admin/kontaktdaten': 'kontaktliste trh notfall telefonliste',
  '/portal/admin/eigentuemerversammlung': 'etv versammlung beschluss protokoll einladung tagesordnung',
  '/portal/mitteilungen': 'rundschreiben mitteilung nachricht ankündigung digest newsletter',
  '/portal/zaehlerstaende': 'zähler strom wasser gas ablesung',
  '/portal/abstimmungen': 'umlaufbeschluss abstimmung beschluss',
  '/portal/termine': 'termin besichtigung terminanfrage',
  '/portal/kalender': 'kalender woche monat',
  '/portal/admin/kontaktanfragen': 'kontaktformular website anfrage',
  '/portal/admin/anfragen': 'self-service anfragen',
  '/portal/admin/mitarbeiter': 'team kollegen benutzer',
  '/portal/admin/berechtigungen': 'rechte rollen zugriff',
  '/portal/admin/email-vorlagen': 'e-mail mail vorlage textbaustein',
  '/portal/admin/email-log': 'e-mail protokoll versand mail-log',
  '/portal/admin/email-einstellungen': 'smtp signatur e-mail',
  '/portal/admin/audit': 'protokoll log änderungen historie',
  '/portal/admin/backups': 'sicherung backup',
  '/portal/admin/papierkorb': 'gelöscht wiederherstellen',
  '/portal/admin/schnittstellen': 'casavi api sync synchronisation immoscout',
  '/portal/admin/hausgeld-mahnwesen': 'hausgeld mahnung rückstand',
  '/portal/admin/onboarding': 'neukunde checkliste übernahme onboarding',
  '/portal/neukunden': 'lead anfrage angebot interessent akquise',
  '/portal/admin/angebote': 'angebot offerte angebotstool',
  '/portal/admin/eigentuemer-berichte': 'bericht report digest eigentümer',
  '/portal/admin/muster-abrechnungen': 'muster abrechnung beispiel',
  '/portal/einstellungen': 'profil passwort konto einstellungen',
  '/portal/ai-assistent': 'sonja ki assistent chat',
  '/portal/admin/ki-wissensbasis': 'wissen faq ki',
  '/portal/admin/exporte': 'export csv excel',
  '/portal/admin/mietspiegel': 'mietspiegel vergleichsmiete',
  '/portal/admin/vertraege': 'vertrag verwaltervertrag vertragsmanagement',
  '/portal/admin/buchungen': 'buchung neue kunden bestellung',
  '/portal/admin/registrierungen': 'registrierung freischaltung',
  '/portal/admin/aenderungsantraege': 'änderungsantrag stammdaten',
  '/portal/admin/empfehlungen': 'empfehlung referral prämie',
  '/portal/hilfe': 'hilfe anleitung support',
  '/portal/benachrichtigungen': 'benachrichtigung glocke',
};

// Zusätzliche Funktionen/Aktionen, die nicht im Menü stehen
export const EXTRA_FEATURES = {
  staff: [
    { label: 'Neuen Kunden anlegen', path: '/portal/admin/kunden/neu', group: 'Aktion', keywords: 'kunde anlegen neu erstellen eigentümer mieter' },
    { label: 'Neues Mietobjekt anlegen', path: '/portal/admin/vermietungen?tab=objekte', group: 'Aktion', keywords: 'mietobjekt vermietung inserat anlegen' },
    { label: 'Mietbewerbungen', path: '/portal/admin/vermietungen?tab=bewerbungen', group: 'Vermietungen', keywords: 'bewerbung bewerber absage zusage wartend' },
    { label: 'Öffentliche Bewerbungsseite', path: '/mietbewerbung', group: 'Vermietungen', keywords: 'bewerbungsformular link interessent' },
  ],
  all: [
    { label: 'Einstellungen & Profil', path: '/portal/einstellungen', group: 'Konto', keywords: 'profil passwort konto' },
    { label: 'Benachrichtigungen', path: '/portal/benachrichtigungen', group: 'Konto', keywords: 'glocke hinweise' },
    { label: 'Hilfe', path: '/portal/hilfe', group: 'Konto', keywords: 'anleitung support faq' },
  ],
};

const norm = (s) => (s || '').toString().toLowerCase()
  .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '');

// Zuletzt geöffnete Treffer (max. 5) – pro Browser im localStorage
const RECENT_KEY = 'skk_search_recent';
export const loadRecents = () => {
  try { const v = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(v) ? v.slice(0, 5) : []; } catch { return []; }
};
export const saveRecent = (item) => {
  if (!item?.url) return loadRecents();
  const next = [{ id: item.id, title: item.title, subtitle: item.subtitle, type: item.type, url: item.url, section: item.section },
    ...loadRecents().filter((r) => r.url !== item.url)].slice(0, 5);
  localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  return next;
};
export const clearRecents = () => { localStorage.removeItem(RECENT_KEY); return []; };

// Menü (verschachtelt) → flache Feature-Liste
export const flattenMenu = (menu, isStaff) => {
  const out = [];
  const seen = new Set();
  const push = (f) => { if (f.path && !seen.has(f.path)) { seen.add(f.path); out.push(f); } };
  (menu || []).forEach((m) => {
    if (m.path) push({ label: m.label, path: m.path, icon: m.icon, group: '' });
    (m.items || []).forEach((it) => { if (it.path) push({ label: it.label, path: it.path, icon: it.icon, group: m.label }); });
  });
  [...(isStaff ? EXTRA_FEATURES.staff : []), ...EXTRA_FEATURES.all].forEach(push);
  return out;
};

export const matchFeatures = (features, query, limit = 6) => {
  const q = norm(query).trim();
  if (q.length < 2) return [];
  const tokens = q.split(/\s+/).filter(Boolean);
  return features
    .map((f) => {
      const label = norm(f.label);
      const hay = `${label} ${norm(f.group)} ${norm(FEATURE_KEYWORDS[f.path.split('?')[0]])} ${norm(f.keywords)}`;
      if (!tokens.every((t) => hay.includes(t))) return null;
      let score = 0;
      if (label === q) score = 100;
      else if (label.startsWith(q)) score = 80;
      else if (label.includes(q)) score = 60;
      else if (norm(f.group).includes(q)) score = 30;
      else score = 20;
      return { ...f, score };
    })
    .filter(Boolean)
    .sort((a, b) => b.score - a.score || a.label.localeCompare(b.label, 'de'))
    .slice(0, limit);
};
